module.exports = __webpack_public_path__ + "media/react/assets/images/dna-genetica-3df789e8b0c7d29cde31ce083707f9b6.png";